<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="用户名" name="user_name"></c-form-item>
					<c-form-item type="input" label="IP地址" name="query_ip"></c-form-item>
					<c-form-item type="input" label="操作内容" name="remark"></c-form-item>
					<c-form-item type="select" label="请求类型" name="query_type" :options="queryType"></c-form-item>
					<c-form-item type="datetime" label="操作时间" start-name="start_execute_date" end-name="end_execute_date"></c-form-item>
				</c-form>
			</m-search>

			<c-table ref="table" code="sys_user_log_list">

				<c-table-column
					label="用户名"
					name="user_name"
					width="100"
				>
				</c-table-column>

				<c-table-column
						label="姓名"
						name="user_realname"
						width="100"
				>
				</c-table-column>

				<c-table-column
					label="请求方式"
					name="query_type"
					width="70"
				>
				</c-table-column>
				
				<c-table-column
					label="请求路径"
					name="query_url"
					width="300"
				>
				</c-table-column>
				
				<c-table-column
					label="操作内容"
					name="remark"
					width="200"
				>
				</c-table-column>

				<c-table-column
						label="操作日期"
						name="execute_date"
						width="140"
				>
				</c-table-column>

				<c-table-column
						label="IP地址"
						name="query_ip"
						width="100"
				>
				</c-table-column>

				<c-table-column
						label="入库日期"
						name="create_date"
						width="140"
				>
				</c-table-column>


			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_sys_user_log',
		
		data() {
			return {
				queryType: [{
					name: 'POST',
					value: 'POST'
				}, {
					name: 'GET',
					value: 'GET'
				}],
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},

		methods: {

			searchHandle(data) {
				this.$refs.table.load({
					url: '/sys_user_logs/list',
					data
				});
			},

		}
	}
</script>